"use client";

import ViuGoOddsMatchCell from "./ViuGoOddsMatchCell";
import ViuGoOddsMatchOuCell from "./ViuGoOddsMatchOuCell";
import ViuGoOddsMatch1x2Cell from "./ViuGoOddsMatch1x2Cell";

const MOBILE_ODDS_LABEL = "text-[6px] leading-[12px] text-[var(--theme-text-muted)]";
const MOBILE_ODDS_VALUE = "text-[9px] leading-[12px]";
const MOBILE_X2_VALUE = "text-[8px] leading-[12px]";
const MOBILE_X2_ROW_COMPACT = "!gap-0.5 !px-0.5";
const MOBILE_X2_TREND_SVG = "h-1 w-[5px]";

export default function ViuGoMobileOddsSlide({
    isHalf,
    handicapLabel,
    homeHandicap,
    homeHandicapTrend,
    awayHandicap,
    awayHandicapTrend,
    overUnderLine,
    overOdds,
    overTrend,
    underOdds,
    underTrend,
    oneX2Home,
    oneX2HomeTrend,
    oneX2Draw,
    oneX2DrawTrend,
    oneX2Away,
    oneX2AwayTrend,
}) {
    const hdpTitle = isHalf ? "HDP H1" : "HDP";
    const ouTitle = isHalf ? "O/U H1" : "O/U";
    const x2Title = isHalf ? "1X2 H1" : "1X2";
    const titleCls =
        "text-center text-[11px] font-bold leading-tight text-[var(--theme-text-muted)]";

    return (
        <div className="grid  min-w-0 grid-cols-[repeat(3,minmax(0,1fr))] gap-x-[2px] p-[5px]">
            <div className="flex min-w-0 flex-col gap-[5px]">
                <div className={titleCls}>
                    {hdpTitle}
                    <br />
                </div>
                <div className="flex flex-col gap-[5px]">
                    <ViuGoOddsMatchCell
                        label={handicapLabel}
                        value={homeHandicap}
                        trend={homeHandicapTrend}
                        labelClassName={MOBILE_ODDS_LABEL}
                        valueClassName={MOBILE_ODDS_VALUE}
                    />
                    <ViuGoOddsMatchCell
                        label=""
                        value={awayHandicap}
                        trend={awayHandicapTrend}
                        labelClassName={MOBILE_ODDS_LABEL}
                        valueClassName={MOBILE_ODDS_VALUE}
                    />
                </div>
            </div>
            <div className="flex min-w-0 flex-col gap-[5px]">
                <div className={titleCls}>
                    {ouTitle}
                    <br />
                </div>
                <div className="flex flex-col gap-[5px]">
                    <ViuGoOddsMatchOuCell
                        line={overUnderLine}
                        side="O"
                        odds={overOdds}
                        trend={overTrend}
                        labelClassName={MOBILE_ODDS_LABEL}
                        valueClassName={MOBILE_ODDS_VALUE}
                    />
                    <ViuGoOddsMatchOuCell
                        line={overUnderLine}
                        side="U"
                        odds={underOdds}
                        trend={underTrend}
                        labelClassName={MOBILE_ODDS_LABEL}
                        valueClassName={MOBILE_ODDS_VALUE}
                    />
                </div>
            </div>
            <div className="flex min-w-0 flex-col gap-[5px]">
                <div className={titleCls}>
                    {x2Title}
                    <br />
                </div>
                <div className="flex min-w-0 flex-col gap-[5px]">
                    <ViuGoOddsMatch1x2Cell
                        value={oneX2Home}
                        trend={oneX2HomeTrend}
                        valueClassName={MOBILE_X2_VALUE}
                        rowClassName={MOBILE_X2_ROW_COMPACT}
                        trendArrowClassName={MOBILE_X2_TREND_SVG}
                        compact
                    />
                    <ViuGoOddsMatch1x2Cell
                        value={oneX2Draw}
                        trend={oneX2DrawTrend}
                        valueClassName={MOBILE_X2_VALUE}
                        rowClassName={MOBILE_X2_ROW_COMPACT}
                        trendArrowClassName={MOBILE_X2_TREND_SVG}
                        compact
                    />
                    <ViuGoOddsMatch1x2Cell
                        value={oneX2Away}
                        trend={oneX2AwayTrend}
                        valueClassName={MOBILE_X2_VALUE}
                        rowClassName={MOBILE_X2_ROW_COMPACT}
                        trendArrowClassName={MOBILE_X2_TREND_SVG}
                        compact
                    />
                </div>
            </div>
        </div>
    );
}
